"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _StyledLayout = require("../../../StyledLayout");

var _Elements = require("../../Elements");

var _Forms = _interopRequireWildcard(require("../../../Forms"));

var _Elements2 = require("./Elements");

var _constants = require("../../constants/constants");

var _excluded = ["colour", "titleSize", "showBelow", "isBoldTitle", "setCanScroll", "onSubmitMessage", "centerSendEmailBtn"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MESSAGE_STATE = {
  UNSENT: 'UNSENT',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

var Contact = function Contact(_ref) {
  var colour = _ref.colour,
      titleSize = _ref.titleSize,
      showBelow = _ref.showBelow,
      isBoldTitle = _ref.isBoldTitle,
      setCanScroll = _ref.setCanScroll,
      onSubmitMessage = _ref.onSubmitMessage,
      centerSendEmailBtn = _ref.centerSendEmailBtn,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var contactBoxRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(MESSAGE_STATE.UNSENT),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      responseState = _useState2[0],
      setResponseState = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      nameInputFocus = _useState4[0],
      setNameInputFocus = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      emailInputFocus = _useState6[0],
      setEmailInputFocus = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      subjectInputFocus = _useState8[0],
      setSubjectInputFocus = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      messageTextareaFocus = _useState10[0],
      setMessageTextareaFocus = _useState10[1]; // eslint-disable-next-line consistent-return


  (0, _react.useEffect)(function () {
    setCanScroll(true);
    return function () {
      return setCanScroll(false);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var _contactBoxRef$curren, _contactBoxRef$curren2;

    // eslint-disable-next-line no-unused-expressions
    contactBoxRef === null || contactBoxRef === void 0 ? void 0 : (_contactBoxRef$curren = contactBoxRef.current) === null || _contactBoxRef$curren === void 0 ? void 0 : (_contactBoxRef$curren2 = _contactBoxRef$curren.focus) === null || _contactBoxRef$curren2 === void 0 ? void 0 : _contactBoxRef$curren2.call(_contactBoxRef$curren);
  }, []);
  var submitMessage = responseState === MESSAGE_STATE.UNSENT ? null : /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    justify: "center",
    mt: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    fontColor: responseState === MESSAGE_STATE.SUCCESS ? 'positive' : 'warning'
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: responseState === MESSAGE_STATE.SUCCESS ? 'portfolio.theme.message.send.success' : 'portfolio.theme.message.send.failure'
  })));
  return /*#__PURE__*/_react["default"].createElement(_Elements2.StyledContactBox, (0, _extends2["default"])({
    flex: true,
    justify: "center"
  }, rest), /*#__PURE__*/_react["default"].createElement(_Elements2.StyledContactInfoBox, (0, _extends2["default"])({
    flex: true,
    align: "center",
    justify: "center",
    column: true
  }, rest), titleSize === 'large' && /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioHeadline, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    center: true,
    mb: "lg",
    normal: !isBoldTitle
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.message.caption.message"
  })), titleSize === 'small' && /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioHeadingMedium, {
    mb: "md",
    portfolioForeground1: true,
    normal: !isBoldTitle
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.message.caption.message"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true,
    mb: "lg",
    center: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.message.description",
    values: {
      below: showBelow ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "portfolio.theme.message.below"
      }) : '.'
    }
  }))), /*#__PURE__*/_react["default"].createElement(_Elements2.StyledFormBox, (0, _extends2["default"])({
    isNameInputFocus: nameInputFocus,
    isEmailInputFocus: emailInputFocus,
    isSubjectInputFocus: subjectInputFocus,
    isMessageTextareaFocus: messageTextareaFocus
  }, rest), /*#__PURE__*/_react["default"].createElement(_Forms["default"], {
    onSubmit: function onSubmit(formVal) {
      onSubmitMessage(formVal, function () {
        return setResponseState(MESSAGE_STATE.SUCCESS);
      }, function () {
        return setResponseState(MESSAGE_STATE.ERROR);
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_Forms.Input, {
    id: "name",
    name: "name",
    isRequired: true,
    label: "portfolio.theme.message.label.name",
    placeholder: "Enter your name",
    onFocus: function onFocus() {
      setNameInputFocus(true);
    },
    onBlur: function onBlur() {
      setNameInputFocus(false);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Forms.EmailInput, {
    id: "email",
    name: "email",
    label: "portfolio.theme.message.label.email",
    placeholder: "Enter your email address",
    onFocus: function onFocus() {
      setEmailInputFocus(true);
    },
    onBlur: function onBlur() {
      setEmailInputFocus(false);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Forms.Input, {
    id: "subject",
    name: "subject",
    label: "portfolio.theme.message.label.subject",
    placeholder: "Enter subject line",
    onFocus: function onFocus() {
      setSubjectInputFocus(true);
    },
    onBlur: function onBlur() {
      setSubjectInputFocus(false);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Forms.Textarea, {
    id: "message",
    name: "message",
    label: "portfolio.theme.message.label.message",
    placeholder: "Write a message here",
    onFocus: function onFocus() {
      setMessageTextareaFocus(true);
    },
    onBlur: function onBlur() {
      setMessageTextareaFocus(false);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Elements2.SubmitBox, {
    flex: true,
    centerSendEmailBtn: centerSendEmailBtn,
    colour: _constants.PORTFOLIO_THEME_COLOR[colour],
    className: "portfolio__contact--submitButton"
  }, /*#__PURE__*/_react["default"].createElement(_Forms.SubmitButton, {
    message: "portfolio.theme.message.cta.send"
  })), submitMessage)));
};

Contact.defaultProps = {
  onSubmitMessage: function onSubmitMessage() {},
  titleSize: 'small',
  isBoldTitle: false,
  colour: '',
  showBelow: true,
  setCanScroll: function setCanScroll() {},
  centerSendEmailBtn: false
};
Contact.propTypes = {
  onSubmitMessage: _propTypes["default"].func,
  titleSize: _propTypes["default"].oneOf(['small', 'large']),
  isBoldTitle: _propTypes["default"].bool,
  colour: _propTypes["default"].string,
  showBelow: _propTypes["default"].bool,
  setCanScroll: _propTypes["default"].func,
  centerSendEmailBtn: _propTypes["default"].bool
};
var _default = Contact;
exports["default"] = _default;